/**
 * Reference Code Mapping for Plot Pavings
 * Maps field names to Evaluate codes (resourceCode in Item Library API)
 */

export interface PlotPavingsReferenceCodeMapping {
  code?: string;
}

/**
 * Plot Pavings Reference Codes
 * Maps field names from plot pavings tables to Evaluate codes
 */
export const PLOT_PAVINGS_REFERENCES: Record<
  string,
  PlotPavingsReferenceCodeMapping
> = {
  // Paving Paths (Slabs)
  pavingLevelCompact: { code: "GWALP005" },
  pavingGeotextileLayer: { code: "ALP031A" },
  pavingSubBase: { code: "GWALP006" }, // Dynamic - varies by user selection (xxxmm Sub base)
  pavingPlainGreyPavings: {}, // Dynamic
  slab900wSteps: { code: "GWALP046" },
  slab1200wSteps: { code: "GWALP046A" },
  slabGravelMarginPea: { code: "GWALP009" },
  slabGravelMarginCotswold: { code: "GWALP009A" },
  slabThresholdDrain: { code: "GWALPDD050" },
  slabShedBase: { code: "GWALP047" },
  slabCycleHoops: { code: "GWALP048" },
  slabRotaryDryer: { code: "GWALP049" },

  // Macadam Paths
  macadamLevelCompact: { code: "GWALP005" },
  macadamGeotextileLayer: { code: "ALP031A" },
  macadamSubBase: { code: "GWALP006" },
  macadamDbBase: {}, // Dynamic - varies by user selection (xxmm DB Base)
  macadamDbBinder: {}, // Dynamic - varies by user selection (xxmm DB Binder)
  macadamSealingGrit: { code: "ALP054" },
  macadamSweepTack: { code: "ALP055" },
  macadamDbSurfaceCourse: {}, // Dynamic - varies by user selection (xxmm DB Surface course)
  macadamHraSurfaceCourse: {}, // Dynamic - varies by user selection (xxmm HRA Surface course)
  macadamSmaSurfaceCourse: {}, // Dynamic - varies by user selection (xxmm SMA Surface course)
  macadamEdgings: { code: "ALP027" },
};

/**
 * Get reference code for a specific field
 */
export const getPlotPavingsReferenceCode = (
  referenceKey: string,
): string | undefined => {
  return PLOT_PAVINGS_REFERENCES[referenceKey]?.code;
};

/**
 * Get full reference information for a specific field
 */
export const getPlotPavingsReference = (
  referenceKey: string,
): PlotPavingsReferenceCodeMapping | undefined => {
  return PLOT_PAVINGS_REFERENCES[referenceKey];
};
